import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
import { hashData } from './search-result-utils';
import { attributeSeparator, valueSeparator } from './transformAnalyticsQueryParamToObject';
export var transformAnalyticsToQueryParam = function transformAnalyticsToQueryParam(_ref) {
  var url = _ref.url,
    query = _ref.query,
    searchSessionId = _ref.searchSessionId,
    additionalAnalytics = _ref.additionalAnalytics,
    resultId = _ref.resultId,
    addQueryParams = _ref.addQueryParams,
    addQuery = _ref.addQuery,
    type = _ref.type;
  var isConfluenceContent = typeof resultId === 'string' && resultId.includes('confluence') || typeof type === 'string' && ['confluence page', 'confluence blogpost', 'confluence space', 'confluence attachment', 'confluence whiteboard'].some(function (contentType) {
    return contentType.includes(type);
  });
  var hasAdditionalAnalytics = _typeof(additionalAnalytics) === 'object' && Object.keys(additionalAnalytics).length > 0;
  if (!isConfluenceContent || !(query || hasAdditionalAnalytics)) {
    return addQuery(url, 'search_id', searchSessionId);
  }
  var events = [];
  if (query) {
    events.push("queryHash".concat(valueSeparator).concat(hashData(query)));
  }
  if (hasAdditionalAnalytics) {
    Object.entries(additionalAnalytics).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        attribute = _ref3[0],
        value = _ref3[1];
      events.push("".concat(attribute).concat(valueSeparator).concat(value));
    });
  }
  if (events.length === 0) {
    return addQuery(url, 'search_id', searchSessionId);
  }
  var analyticsFormattedForUrlParsing = encodeURIComponent(events.join(attributeSeparator));
  return addQueryParams(url, {
    search_id: searchSessionId,
    additional_analytics: analyticsFormattedForUrlParsing
  });
};